import { render, staticRenderFns } from "./SectionWebchat.vue?vue&type=template&id=21bf6712&scoped=true&"
import script from "./SectionWebchat.vue?vue&type=script&lang=js&"
export * from "./SectionWebchat.vue?vue&type=script&lang=js&"
import style0 from "./SectionWebchat.vue?vue&type=style&index=0&id=21bf6712&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf6712",
  null
  
)

export default component.exports